import Button from 'components/actions/Button';
import Dialog from 'components/overlays/Dialog';

interface Props {
    vin: string | null;
    isLoading?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const DeleteSimulationDialog = ({ vin, isLoading, onConfirm, onCancel }: Props) => (
    <Dialog
        show={vin !== null}
        title='Delete simulation'
        showCloseButton
        onClose={onCancel}
        body={
            <p>
                Are you sure you want to delete the simulation for VIN <strong>{vin}</strong>? This action cannot be
                undone.
            </p>
        }
        footer={
            <div className='display-flex gap-10 justify-content-end'>
                <Button onClick={onCancel} data-testid='domain-sim-delete-cancel'>
                    Cancel
                </Button>
                <Button
                    style='danger'
                    onClick={onConfirm}
                    isLoading={isLoading}
                    data-testid='domain-sim-delete-confirm'
                >
                    Delete
                </Button>
            </div>
        }
    />
);

export default DeleteSimulationDialog;
